import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodAdcTruckLoadGT38Dialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog('ChangeDeliveryMethodAdcTruckLoadGT38Dialog');
    }
    componentDidMount() {
        // window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    handleNo(event){
        event && event.preventDefault();
        const self = this;
        this.setState({
            showDialog: false,
        });
        self.props.changeHandleNo(self.state.deliveryMethod);
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodAdcTruckLoadGT38Dialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order has enough points to qualify for direct shipment.</p>
                    <p><b>ADC Truckload orders are tailgate delivery only and cannot include uncrating or any installation services.</b></p>
                    <p><b>Would you like to have it shipped ADC Truckload?</b></p>
                    <div className="noButtonContainer">
                            <a href="" className="noButton blueButton" onClick={this.handleNo.bind(this)}>No</a>
                        </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={(e) => this.props.continueDeliveryWith("ADC Truckload", e)}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ChangeDeliveryMethodAdcTruckLoadGT38Dialog = connect(mapStateToProps)(ChangeDeliveryMethodAdcTruckLoadGT38Dialog);
export default ChangeDeliveryMethodAdcTruckLoadGT38Dialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeDeliveryMethodAdcTruckLoadGT38Dialog.js